import { Injectable } from '@angular/core'

import { SaleItem } from './sale-item'

@Injectable()
export class SaleItemSerializer {
  fromJson(json: any): SaleItem {
    const saleItem = json

    return saleItem
  }

  toJson(saleitem: SaleItem): any {
    return {
      ...saleitem
    }
  }
}
